import { render, staticRenderFns } from "./resetPwd.vue?vue&type=template&id=454d9b71&scoped=true&"
import script from "./resetPwd.vue?vue&type=script&lang=js&"
export * from "./resetPwd.vue?vue&type=script&lang=js&"
import style0 from "./resetPwd.vue?vue&type=style&index=0&id=454d9b71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454d9b71",
  null
  
)

export default component.exports